<template>
  <div id="hit-header" class="bg-header">
    <div class="flex items-center justify-between w-full">
      <div
        class="px-2 header cursor-pointer flex flex-row items-center bg-transparent"
        @click="navigateHome"
      >
        <div
          v-if="responsiveBreakpointMd"
          class="icon-wrapper flex items-center justify-center logo-style"
        >
          <svg
            id="svg1"
            class="logo-color"
            width="50.963001mm"
            height="50.963001mm"
            viewBox="0 0 50.963002 50.963001"
            version="1.1"
            inkscape:version="1.4 (e7c3feb100, 2024-10-09)"
            sodipodi:docname="hit-online-avatar-black.svg"
            xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
            xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:svg="http://www.w3.org/2000/svg"
          >
            <sodipodi:namedview
              id="namedview1"
              pagecolor="#ffffff"
              borderopacity="0.25"
              inkscape:showpageshadow="2"
              inkscape:pageopacity="0.0"
              inkscape:pagecheckerboard="true"
              inkscape:deskcolor="#d1d1d1"
              inkscape:document-units="mm"
              inkscape:zoom="2.7185938"
              inkscape:cx="79.820678"
              inkscape:cy="91.591469"
              inkscape:window-width="3440"
              inkscape:window-height="1403"
              inkscape:window-x="0"
              inkscape:window-y="0"
              inkscape:window-maximized="1"
              inkscape:current-layer="layer1"
              showgrid="false"
            />
            <defs id="defs1">
              <clipPath id="clipPath14" clipPathUnits="userSpaceOnUse">
                <path
                  id="path14"
                  d="M 0,841.89 H 1190.551 V 0 H 0 Z"
                  transform="translate(-618.87962,-493.17621)"
                />
              </clipPath>
              <clipPath id="clipPath16" clipPathUnits="userSpaceOnUse">
                <path
                  id="path16"
                  d="M 0,841.89 H 1190.551 V 0 H 0 Z"
                  transform="translate(-563.16564,-420.94411)"
                />
              </clipPath>
              <clipPath id="clipPath18" clipPathUnits="userSpaceOnUse">
                <path
                  id="path18"
                  d="M 0,841.89 H 1190.551 V 0 H 0 Z"
                  transform="translate(-611.92082,-431.68201)"
                />
              </clipPath>
              <clipPath id="clipPath20" clipPathUnits="userSpaceOnUse">
                <path
                  id="path20"
                  d="M 0,841.89 H 1190.551 V 0 H 0 Z"
                  transform="translate(-730.97102,-420.94491)"
                />
              </clipPath>
            </defs>
            <g
              id="layer1"
              inkscape:label="Layer 1"
              inkscape:groupmode="layer"
              transform="translate(-36.160304,-27.436081)"
            >
              <g id="g1" transform="translate(4.2464003)">
                <path
                  id="path13"
                  d="m 0,0 h -2.667 c -2.37,0 -4.292,-1.922 -4.292,-4.292 v -40.531 c 9.254,-5.642 15.466,-15.801 15.466,-27.409 0,-11.609 -6.212,-21.766 -15.466,-27.408 v -40.531 c 0,-2.37 1.922,-4.292 4.292,-4.292 h 34.965 c 2.37,0 4.292,1.922 4.292,4.292 V -36.59 C 36.59,-16.382 20.208,0 0,0"
                  style="fill-opacity: 1; fill-rule: nonzero; stroke: none"
                  transform="matrix(0.35277776,0,0,-0.35277776,65.722366,27.436081)"
                  clip-path="url(#clipPath14)"
                />
                <path
                  id="path15"
                  d="M 0,0 C 0,11.606 6.209,21.762 15.459,27.405 V 67.94 c 0,2.371 -1.922,4.292 -4.292,4.292 h -34.959 c -2.37,0 -4.292,-1.921 -4.292,-4.292 v -96.626 c 0,-22.419 16.942,-40.882 38.722,-43.281 2.561,-0.282 4.821,1.715 4.821,4.292 v 40.272 C 6.209,-21.761 0,-11.605 0,0"
                  style="fill-opacity: 1; fill-rule: nonzero; stroke: none"
                  transform="matrix(0.35277776,0,0,-0.35277776,46.067715,52.959801)"
                  clip-path="url(#clipPath16)"
                />
                <path
                  id="path17"
                  d="m 0,0 c -3.539,5.468 -9.662,9.112 -16.645,9.112 -7.015,0 -13.158,-3.682 -16.689,-9.193 -1.976,-3.086 -3.159,-6.728 -3.159,-10.657 0,-3.927 1.183,-7.57 3.159,-10.655 3.531,-5.51 9.674,-9.193 16.689,-9.193 6.983,0 13.106,3.645 16.645,9.112 2.007,3.101 3.203,6.776 3.203,10.736 C 3.203,-6.776 2.007,-3.101 0,0"
                  style="fill-opacity: 1; fill-rule: nonzero; stroke: none"
                  transform="matrix(0.35277776,0,0,-0.35277776,63.267456,49.129973)"
                  clip-path="url(#clipPath18)"
                />
              </g>
            </g>
          </svg>
        </div>
        <div v-if="responsiveBreakpointMd">
          <span class="text-header text-base leading-none px-2.5 logo-text">
            Hit-Online
          </span>
        </div>
      </div>

      <!-- Modern Language Selector -->
      <div class="header-language-selector">
        <div
          class="language-dropdown-container"
          @click="toggleLanguageDropdown"
        >
          <div class="language-selected">
            <span class="language-flag">{{ getCurrentLanguageFlag() }}</span>
            <span class="language-name">{{ getCurrentLanguageName() }}</span>
            <svg
              class="dropdown-icon"
              :class="{rotated: showLanguageDropdown}"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M6 9L12 15L18 9"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <div v-if="showLanguageDropdown" class="language-options">
            <div
              v-for="lang in availableLanguages"
              :key="lang.code"
              class="language-option"
              :class="{active: locale === lang.code}"
              @click.stop="selectLanguage(lang.code)"
            >
              <span class="language-flag">{{ lang.flag }}</span>
              <span class="language-name">{{ lang.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="hit-header-bottom">
      <slot name="bottom" />
    </div>
  </div>
</template>

<script lang="ts">
import {useI18n} from 'vue-i18n';
import HitSelect from '@hit/components/src/components/form/input/HitSelect.vue';
import HitInput from '@hit/components/src/components/form/input/HitInput.vue';
import HitForm from '@hit/components/src/components/form/HitForm.vue';
import {required} from '@vuelidate/validators';
import {defineComponent} from 'vue';
import {
  HitAvatar,
  HitBreakpointsMixin,
  HitButton,
  HitIcon,
} from '@hit/components/src';
import HitCountryFlag from '@hit/components/src/components/icon/HitCountryFlag.vue';
import {HitLanguageUtils} from '@hit/base/src/utils';

export default defineComponent({
  name: 'AdminUIHeader',
  components: {
    HitCountryFlag,
    HitButton,
    HitAvatar,
    HitIcon,
    HitSelect,
    HitInput,
    HitForm,
  },
  mixins: [HitBreakpointsMixin],
  setup() {
    const {t, locale} = useI18n();
    return {t, locale};
  },
  data() {
    return {
      languages: {},
      selectedLanguage: {},
      showLanguageDropdown: false,
      availableLanguages: [
        {code: 'fr-BE', flag: '🇫🇷', name: 'Français'},
        {code: 'nl-BE', flag: '🇳🇱', name: 'Nederlands'},
        {code: 'de-BE', flag: '🇩🇪', name: 'Deutsch'},
        {code: 'en-GB', flag: '🇬🇧', name: 'English'},
        {code: 'mr-IN', flag: '🇮🇳', name: 'Marathi'},
        {code: 'hi-IN', flag: '🇮🇳', name: 'Hindi'},
      ],
    };
  },
  computed: {
    validations() {
      return {
        country: {required},
      };
    },
  },
  mounted() {
    const locale = String(this.locale).replace(/-/g, '_').toLowerCase();
    this.selectedLanguage =
      HitLanguageUtils.getAvailableLanguageOptions(locale)[0]; //use to defined default language at startup
    this.languages = HitLanguageUtils.getSupportedLanguageOptions();

    // Restore saved language preference
    const savedLanguage = localStorage.getItem('selectedLanguage');
    if (savedLanguage) {
      this.locale = savedLanguage;
    }

    // Close language dropdown when clicking outside
    document.addEventListener('click', (event) => {
      const target = event.target as HTMLElement;
      const languageSelector = document.querySelector(
        '.header-language-selector'
      );
      if (languageSelector && !languageSelector.contains(target)) {
        this.showLanguageDropdown = false;
      }
    });
  },
  methods: {
    navigateHome() {
      // Add navigation logic here if needed
      console.info('Navigate to home');
    },
    toggleLanguageDropdown() {
      this.showLanguageDropdown = !this.showLanguageDropdown;
    },
    selectLanguage(code: string) {
      this.locale = code;
      localStorage.setItem('selectedLanguage', code);
      this.showLanguageDropdown = false;
    },
    getCurrentLanguageFlag() {
      const lang = this.availableLanguages.find((l) => l.code === this.locale);
      return lang ? lang.flag : '🌐';
    },
    getCurrentLanguageName() {
      const lang = this.availableLanguages.find((l) => l.code === this.locale);
      return lang ? lang.name : 'Language';
    },
  },
});
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#hit-header {
  display: flex;
  align-items: center;
  padding: 0.3em 0.1em;
  position: relative;
}

.icon-wrapper {
  width: 40px;
  height: 40px;
  margin-left: 4px;
  opacity: 90%;
}

.logo-style {
  width: 30px;
  height: 30px;
}

.logo-text {
  font-size: 16px;
  opacity: 90%;
}

.logo-color path {
  fill: var(--color-logo);
}

/* Modern Language Selector Styles */
.header-language-selector {
  position: relative;
  z-index: 9999;
  margin-right: 1rem;
}

.language-dropdown-container {
  position: relative;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 0.75rem;
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  color: #0d3749;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(20px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  min-width: 140px;
  z-index: 9999;
}

.language-dropdown-container:hover {
  background: rgba(255, 255, 255, 1);
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  border-color: rgba(0, 153, 124, 0.3);
}

.language-selected {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.language-flag {
  font-size: 1.1em;
}

.language-name {
  font-weight: 500;
  white-space: nowrap;
}

.dropdown-icon {
  transition: transform 0.3s ease;
  color: #6b7280;
}

.dropdown-icon.rotated {
  transform: rotate(180deg);
}

.language-options {
  position: absolute;
  top: calc(100% + 0.5rem);
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 0.75rem;
  padding: 0.5rem 0;
  backdrop-filter: blur(20px);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  animation: slideDown 0.2s ease-out;
  z-index: 10000;
}

.language-option {
  padding: 0.75rem 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.language-option:hover {
  background: linear-gradient(
    135deg,
    rgba(0, 153, 124, 0.1),
    rgba(26, 188, 156, 0.1)
  );
}

.language-option.active {
  background: linear-gradient(
    135deg,
    rgba(0, 153, 124, 0.15),
    rgba(26, 188, 156, 0.15)
  );
  color: #00997c;
  font-weight: 600;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .header-language-selector {
    margin-right: 0.75rem;
  }

  .language-dropdown-container {
    padding: 0.375rem 0.5rem;
    font-size: 0.8rem;
    min-width: 120px;
  }
}

@media (max-width: 480px) {
  .header-language-selector {
    margin-right: 0.5rem;
  }

  .language-dropdown-container {
    padding: 0.25rem 0.375rem;
    font-size: 0.75rem;
    min-width: 100px;
  }
}
</style>
